"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CTAButton_1 = __importDefault(require("../call-to-action/CTAButton"));
var Section_1 = __importDefault(require("../elements/Section"));
var Kontakt_1 = require("../../defaults/Kontakt");
var _helpers_1 = require("../../helpers");
var react_1 = __importDefault(require("react"));
var Contact = function (_a) {
    var sectionConfig = _a.sectionConfig, full = _a.full, text = _a.text, subline = _a.subline, link = _a.link, onClick = _a.onClick;
    var mergedSectionConfig = _helpers_1.merge(Kontakt_1.defaultSectionConfig, sectionConfig);
    return (react_1.default.createElement(Section_1.default, __assign({}, mergedSectionConfig),
        react_1.default.createElement(CTAButton_1.default, { full: full, dark: mergedSectionConfig.dark, text: text, subline: subline, link: link, onClick: onClick })));
};
exports.default = Contact;
//# sourceMappingURL=Kontakt.js.map